import React from 'react';

const logo = require("./imgs/logo.png");

const Header = () => {
  return (
    <header className="padding-0 font-congenialBlack font-bold bg-dark border-b border-[#5A3770]">
      {/* Top Navigation Bar */}
      <div className="bg-dark text-white py-3">
        <div className="max-w-7xl mx-auto px-6">
          {/* Use flex-col on mobile, flex-row on md+ */}
          <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">

            {/* Logo */}
            <div className="flex items-center space-x-2 justify-center md:justify-end">
              <img src={logo} alt="logo" />
            </div>

            {/* Navigation Menu */}
            <nav className="flex flex-wrap justify-center md:justify-end space-x-2 md:space-x-8">
              <a
                href="/menu"
                className="text-white hover:text-gray-300 transition-colors duration-300 font-medium"
              >
                Menu
              </a>
              <a
                href="/findaninsomnia"
                className="text-white hover:text-gray-300 transition-colors duration-300 font-medium"
              >
                Find a Bakery
              </a>
              <a
                href="/menu"
                className="text-white hover:text-gray-300 transition-colors duration-300 font-medium"
              >
                Catering
              </a>
              <a
                href="/contact-sales"
                className="text-white hover:text-gray-300 transition-colors duration-300 font-medium"
              >
                Contact Sales
              </a>
            </nav>

          </div>
        </div>
      </div>
    </header>
  );
};


export default Header;
